import { render } from "preact";
import { LazyCss } from "../components/css";

const Home = () => {
  return <div class="h-full bg-no-repeat text-white text-center monorail-header">
      <LazyCss url="https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" />
      <LazyCss url="https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap" />

      <div class="pt-20 pb-40 md:p-20 md:pt-40 max-w-[1000px] mx-auto">

        <img class="px-6 md:px-10 mb-4" src="/logo.png" alt="Monorail Technology logo" />

        <div class="text-2xl md:text-3xl bg-opacity-90 px-6 md:px-10 md:py-8 py-5 text-left leading-snug md:leading-normal">
          <span class="font-semibold">Monorail Technology, LLC</span> is a
          security consulting and software R&amp;D shop run by Jesse Kriss, applying
          expertise in information security and compliance, cloud infrastructure, appropriate scale technology, and
          user-focused design, bringing creative solutions to complex technical
          and user experience problems.
        </div>
        {/* <div class="text-left text-2xl md:text-3xl px-6 md:px-10 py-5">
          Read more and subscribe at{" "}
          <a
            href="https://workshop.monorail.tech/"
            class="underline underline-offset-4 decoration-purple-600 hover:decoration-purple-500"
          >
            <span class="font-semibold">the workshop</span>
          </a>
          .
        </div>*/}
        <div class="text-left text-2xl md:text-3xl px-6 md:px-10 py-5">
          <a
            href="/about"
            class="underline underline-offset-4 decoration-purple-600 hover:decoration-purple-500"
          >Why trust Monorail?</a>
        </div>
        {/* <div class="text-left text-2xl md:text-3xl px-6 md:px-10 py-5">
          <a href="https://safestack.io/managed-application-security-service" class="underline underline-offset-4 decoration-purple-600 hover:decoration-purple-500">
            Level up your application security program
          </a><br/>
          (in partnership with SafeStack)
        </div>*/}
        <div class="text-left text-2xl md:text-3xl px-6 md:px-10 py-5">
          <a href="/soc2" class="underline underline-offset-4 decoration-purple-600 hover:decoration-purple-500">Looking for help with SOC 2?</a>
        </div>
        {/* <div class="text-left text-2xl md:text-3xl px-6 md:px-10 py-5">
          <a href="/appsec" class="underline underline-offset-4 decoration-purple-600 hover:decoration-purple-500">Looking for help with Application Security?</a>
        </div>*/}
        <div class="text-left text-lg px-6 md:px-10 py-5 ">
          Get in touch:{" "}
          <a href="mailto:jesse@monorail.tech">jesse@monorail.tech</a>
        </div>
      </div>
    </div>
}

render(<Home />, document.querySelector("main"));
